(function() {
    'use strict'

    var pluginName = "galleryGrid";
    var defaults = {
    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);    // merge contents of objects into first object
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        init() {
            this.$element = $(this.element);
            this.$imageContainer = $('.js-images', this.element);
            this.$images = $('img', this.element);
            this.$gridNav = $('.js-grid-nav', this.element);
            this.$clone = null;
            this.$target = null;

            this.bindEvents();
        },

        copyImage(e) {
            this.$target = $(e.currentTarget);
            const offset = this.$element.offset();
            const data = this.$target.offset();
            this.$clone = this.$target.clone();
            this.$target.parent().addClass('loading');
            this.$element.addClass('loading');

            this.$clone.attr('sizes', '100vw');
            this.$clone.addClass('gallery-grid__clone-image');
            this.$clone.css({
                width: this.$target.outerWidth(),
                height: this.$target.outerHeight(),
                top: data.top - offset.top,
                left: data.left - offset.left
            });

            this.$imageContainer.append(this.$clone);
            this.bindCloneEvents();
        },

        scaleImage() {
            const galleryH = this.$imageContainer.outerHeight();
            const galleryW = this.$imageContainer.outerWidth();

            this.$clone.css({
                width: galleryW,
                height: galleryH,
                top: 0,
                left: 0
            });
        },

        scaleDownImage() {
            const offset = this.$element.offset();
            const data = this.$target.offset();

            this.$clone.css({
                width: this.$target.outerWidth(),
                height: this.$target.outerHeight(),
                top: data.top - offset.top,
                left: data.left - offset.left
            });
        },

        transitionend(e) {
            const slideIndex = this.$target.parents('.row').find('div[class*="col"]').index(this.$target.parents('div[class*="col"]'));

            this.$clone.off('transitionend');
            this.$clone.off('load');
            this.$clone.css({
                width: '100%',
                height: '100%'
            });

            if (typeof this.element.scrollIntoView === 'function') {
                this.element.scrollIntoView({
                    block: 'start',
                    inline: 'nearest',
                    behavior: 'smooth'
                });
                setTimeout(() => {
                    $('.js-header').addClass('is-hidden');
                }, 500);
            }
            $('.js-slick-slider').trigger('showSlide', {slideIndex: slideIndex});
            this.$gridNav.removeClass('is-hidden');
        },

        removeClone() {
            if (this.$clone) {
                this.$clone.remove();
            }
            this.$clone = null;
        },

        showImage(e) {
            if (this.$clone === null) {
                this.copyImage(e);
            }
        },

        replaceImage(e, data) {
            const index = data.index;
            this.removeClone();
            this.replaceClone(index);
        },

        replaceClone(index) {
            this.$target = this.$images.eq(index);
            this.$clone = this.$target.clone();

            this.$clone.attr('sizes', '100vw');
            this.$clone.addClass('gallery-grid__clone-image');

            this.$imageContainer.append(this.$clone);
            this.scaleImage();
        },

        imageLoaded(e) {
            this.$target.parent().removeClass('loading');
            this.$element.removeClass('loading');
            this.scaleImage();
        },

        hideImage() {
            if (this.$clone) {
                this.scaleDownImage();
                window.setTimeout(function() {
                    this.removeClone();
                }.bind(this), 500);
            }
        },

        hideSlick() {
            $('.js-slick-slider').trigger('hideSlide');
            this.hideImage();
        },

        // EVENTS
        bindEvents() {
            this.$images.on('click', this.showImage.bind(this));
            this.$gridNav.on('click', this.hideSlick.bind(this));
            this.$element.on('hideImage', this.hideImage.bind(this));
            this.$element.on('replaceImage', this.replaceImage.bind(this));
            this.$element.on('hideImage', this.hideImage.bind(this));
        },

        bindCloneEvents() {
            this.$clone.on('transitionend', this.transitionend.bind(this));
            this.$clone.on('load', this.imageLoaded.bind(this));
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());
